// Timezone types and constants

export interface TimezoneOption {
  value: string
  label: string
}

export interface TimezoneGroup {
  label: string
  timezones: TimezoneOption[]
}

// Organized timezone groups
export const TIMEZONE_GROUPS: TimezoneGroup[] = [
  {
    label: 'North America',
    timezones: [
      { value: 'America/New_York', label: 'Eastern Time (ET)' },
      { value: 'America/Chicago', label: 'Central Time (CT)' },
      { value: 'America/Denver', label: 'Mountain Time (MT)' },
      { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
      { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
      { value: 'Pacific/Honolulu', label: 'Hawaii Time (HST)' },
      { value: 'America/Toronto', label: 'Toronto (EST/EDT)' },
      { value: 'America/Vancouver', label: 'Vancouver (PST/PDT)' },
    ]
  },
  {
    label: 'Europe & Africa',
    timezones: [
      { value: 'Europe/London', label: 'London (GMT/BST)' },
      { value: 'Europe/Paris', label: 'Paris (CET/CEST)' },
      { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)' },
      { value: 'Europe/Rome', label: 'Rome (CET/CEST)' },
      { value: 'Europe/Madrid', label: 'Madrid (CET/CEST)' },
      { value: 'Europe/Amsterdam', label: 'Amsterdam (CET/CEST)' },
      { value: 'Europe/Zurich', label: 'Zurich (CET/CEST)' },
      { value: 'Europe/Vienna', label: 'Vienna (CET/CEST)' },
      { value: 'Europe/Stockholm', label: 'Stockholm (CET/CEST)' },
      { value: 'Europe/Oslo', label: 'Oslo (CET/CEST)' },
      { value: 'Europe/Copenhagen', label: 'Copenhagen (CET/CEST)' },
      { value: 'Europe/Helsinki', label: 'Helsinki (EET/EEST)' },
      { value: 'Europe/Warsaw', label: 'Warsaw (CET/CEST)' },
      { value: 'Europe/Prague', label: 'Prague (CET/CEST)' },
      { value: 'Europe/Budapest', label: 'Budapest (CET/CEST)' },
      { value: 'Europe/Athens', label: 'Athens (EET/EEST)' },
      { value: 'Europe/Istanbul', label: 'Istanbul (TRT)' },
      { value: 'Europe/Moscow', label: 'Moscow (MSK)' },
      { value: 'Africa/Cairo', label: 'Cairo (EET)' },
      { value: 'Africa/Johannesburg', label: 'Johannesburg (SAST)' },
      { value: 'Africa/Lagos', label: 'Lagos (WAT)' },
    ]
  },
  {
    label: 'Asia',
    timezones: [
      { value: 'Asia/Dubai', label: 'Dubai (GST)' },
      { value: 'Asia/Karachi', label: 'Karachi (PKT)' },
      { value: 'Asia/Kolkata', label: 'Kolkata (IST)' },
      { value: 'Asia/Dhaka', label: 'Dhaka (BST)' },
      { value: 'Asia/Bangkok', label: 'Bangkok (ICT)' },
      { value: 'Asia/Jakarta', label: 'Jakarta (WIB)' },
      { value: 'Asia/Manila', label: 'Manila (PHT)' },
      { value: 'Asia/Shanghai', label: 'Shanghai (CST)' },
      { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT)' },
      { value: 'Asia/Taipei', label: 'Taipei (CST)' },
      { value: 'Asia/Seoul', label: 'Seoul (KST)' },
      { value: 'Asia/Tokyo', label: 'Tokyo (JST)' },
    ]
  },
  {
    label: 'Australia & Pacific',
    timezones: [
      { value: 'Australia/Sydney', label: 'Sydney (AEST/AEDT)' },
      { value: 'Australia/Melbourne', label: 'Melbourne (AEST/AEDT)' },
      { value: 'Australia/Brisbane', label: 'Brisbane (AEST)' },
      { value: 'Australia/Perth', label: 'Perth (AWST)' },
      { value: 'Australia/Adelaide', label: 'Adelaide (ACST/ACDT)' },
      { value: 'Pacific/Auckland', label: 'Auckland (NZST/NZDT)' },
    ]
  },
  {
    label: 'South America',
    timezones: [
      { value: 'America/Sao_Paulo', label: 'São Paulo (BRT)' },
      { value: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires (ART)' },
      { value: 'America/Santiago', label: 'Santiago (CLT)' },
      { value: 'America/Lima', label: 'Lima (PET)' },
      { value: 'America/Bogota', label: 'Bogotá (COT)' },
      { value: 'America/Mexico_City', label: 'Mexico City (CST/CDT)' },
      { value: 'America/Caracas', label: 'Caracas (VET)' },
    ]
  },
  {
    label: 'UTC',
    timezones: [
      { value: 'UTC', label: 'UTC (GMT)' },
    ]
  }
]

